module.exports = __webpack_public_path__ + "static/media/  (1).bf21a929.jpg";